import alert from '@/plugins/alert'
import { Book } from '@/plugins/api'
import axios from '@/plugins/axios'
const UPLOAD_API = '/upload/'
const DESTROY_API = '/upload/files/'
export default {
  namespaced: true,
  state: {
    book: {},
    count: 0,
    imgs: []
  },
  actions: {
    uploadImgs ({ commit }, formData) {
      return axios.post(UPLOAD_API, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          commit('setImgs', response)
          alert.success('Upload successfully!')
        })
        .catch(e => alert.error(e))
    },
    async fetchBook ({ commit }, bookId) {
      const book = await Book.fetchOne(bookId)
      commit('setBook', book)
      commit('setImgs', book.imgs)
    },
    async createBook ({ commit }, { data, options }) {
      commit('setBook', await Book.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async updateBook ({ commit, state }, { id, ...book }) {
      commit('setBook', await Book.update(id, book))
      alert.success('Cập nhật thành công!')
    },
    setBook ({ commit, state }, book) {
      commit('setBook', book)
    },
    destroyImage ({ commit }, id) {
      commit('setLoading', true)
      return axios.delete(DESTROY_API + id)
        .then(data => {
          commit('removeImg', id)
          alert.success('Xóa thành công!')
        })
        .catch(e => alert.error(e))
    }
  },
  mutations: {
    setBook (state, book) {
      state.book = book
    },
    setImgs (state, imgs) {
      state.imgs = [...imgs, ...state.imgs]
    },
    removeImg (state, id) {
      state.student = {
        ...state.student,
        imgs: state.student.imgs.filter(i => i.id !== id)
      }
    }
  },
  getters: {
    book: (state) => {
      return state.book
    },
    imgs: (state) => {
      return state.imgs
    },
    count: (state) => {
      return state.count
    }
  }
}
